import React from 'react';

const About: React.FC = () => {
  const stats = [
    { label: 'YEARS EXPERIENCE', value: '5+' },
    { label: 'PROJECTS COMPLETED', value: '4+' },
    { label: 'HAPPY CLIENTS', value: '20+' },
    { label: 'TEAM MEMBERS', value: '5+' }
  ];

  const values = [
    {
      title: 'INNOVATION',
      description: 'We constantly push the boundaries of what\'s possible in technology, creating solutions that are ahead of their time.'
    },
    {
      title: 'QUALITY',
      description: 'Every line of code, every feature, and every solution is crafted with meticulous attention to detail and quality assurance.'
    },
    {
      title: 'RELIABILITY',
      description: 'Our systems are built to be robust, scalable, and dependable, ensuring your business operations never skip a beat.'
    },
    {
      title: 'PARTNERSHIP',
      description: 'We work closely with our clients, understanding their needs and building long-term relationships based on trust and results.'
    }
  ];

  return (
    <section id="about" className="py-16 bg-bkash-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-bkash-dark mb-4 border-b-2 border-bkash-red pb-2">
            ABOUT TEKNURA
          </h2>
          <p className="text-lg text-bkash-gray max-w-3xl mx-auto">
            We are a forward-thinking technology company dedicated to solving complex business challenges 
            through innovative software solutions and digital transformation strategies.
          </p>
        </div>

        {/* Company Story */}
        <div className="mb-16">
          <div className="bg-bkash-bg border-2 border-bkash-red p-8 max-w-4xl mx-auto rounded-lg shadow-sm">
            <h3 className="text-2xl font-bold text-bkash-dark mb-6 text-center">
              OUR STORY
            </h3>
            <div className="space-y-4 text-bkash-dark">
              <p>
                Founded in 2019, TEKNURA began as a small team of passionate developers and designers 
                with a vision to create technology that makes a difference. What started as a simple 
                idea has grown into a comprehensive technology company serving businesses across multiple industries.
              </p>
              <p>
                Our journey has been driven by a simple principle: technology should solve real problems 
                and make life easier for businesses and their customers. We believe in building solutions 
                that are not just functional, but intuitive, scalable, and future-proof.
              </p>
              <p>
                Today, we continue to innovate and expand our portfolio, always staying true to our 
                commitment to quality, reliability, and customer satisfaction. Our team has grown, 
                our expertise has deepened, but our passion for excellence remains unchanged.
              </p>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="mb-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {stats.map((stat, index) => (
              <div key={index} className="text-center border-2 border-bkash-blue p-6 bg-bkash-white rounded-lg shadow-sm">
                <div className="text-3xl md:text-4xl font-bold text-bkash-blue mb-2">
                  {stat.value}
                </div>
                <div className="text-sm text-bkash-gray">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Core Values */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-bkash-dark mb-8 text-center">
            OUR CORE VALUES
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {values.map((value, index) => (
              <div key={index} className="border-2 border-bkash-red p-6 bg-bkash-white rounded-lg shadow-sm">
                <h4 className="text-xl font-bold text-bkash-dark mb-4 border-b border-bkash-red pb-2">
                  {value.title}
                </h4>
                <p className="text-bkash-gray">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Technology Stack */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-bkash-dark mb-6">
            TECHNOLOGY EXPERTISE
          </h3>
          <div className="bg-bkash-bg border-2 border-bkash-blue p-6 max-w-4xl mx-auto rounded-lg shadow-sm">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div className="text-bkash-blue font-bold">FRONTEND</div>
              <div className="text-bkash-dark">React, Vue</div>
              <div className="text-bkash-blue font-bold">BACKEND</div>
              <div className="text-bkash-dark">Golang, Python, PHP</div>
              <div className="text-bkash-blue font-bold">DATABASE</div>
              <div className="text-bkash-dark">PostgreSQL, MongoDB, MySQL</div>
              <div className="text-bkash-blue font-bold">CLOUD</div>
              <div className="text-bkash-dark">AWS, Azure, Google Cloud</div>
              <div className="text-bkash-blue font-bold">MOBILE</div>
              <div className="text-bkash-dark">React Native, Flutter</div>
              <div className="text-bkash-blue font-bold">DEVOPS</div>
              <div className="text-bkash-dark">Docker, Kubernetes, CI/CD</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
